module.exports = __webpack_public_path__ + "img/symbol-noteq-right.efb2e304.png";